module.exports = __webpack_public_path__ + "static/img/title_4_blue@2x.52bc8a00.png";